import { observable } from 'mobx'
import * as moment from 'moment'

export default class userProjectsPrefStore {
  @observable data = []
  @observable created = false
  @observable datasetId = ''
  @observable userId = ''
  @observable
  goal = {
    id: 0,
    goalStartDate: moment()
      .subtract(8, 'weeks')
      .format('l'),
    durationMinGoalLow: 30,
    pagesGoalLow: 240,
    pagesGoalHigh: 480,
    pagesGoalSuperHigh: 30,
    type: 'goal',
    indicatorColor: 'lightblue',
    mood: 0,
    description: '',
    incrementalChangeMins: 0
  }

  updateData(d) {
    this.data = d
  }

  updateGoal() {
    //todo
    if (this.data.length !== 0) {
      this.goal = this.data.goal.value
    }
  }

  updateCreated() {
    this.created = true
  }
}



// WEBPACK FOOTER //
// ./src/stores/userProjectsPrefStore.js